/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Remove no-js class when javascript is enabled
Slzr.jQuery(document.documentElement).removeClass('no-js');

// Fix embedded fonts in IE8
//
// Based on:
//  https://github.com/FortAwesome/Font-Awesome/issues/954#issuecomment-65414146
//  http://stackoverflow.com/a/10557782
if ((window.attachEvent != null) && (window.addEventListener == null)) {
  const head = document.getElementsByTagName('head')[0];
  const style = document.createElement('style');
  style.type = 'text/css';
  style.styleSheet.cssText = "html.ie8-font-fix :before,html.ie8-font-fix :after{content: '' !important;}";
  head.appendChild(style);

  const htmlEl = document.documentElement;
  const htmlClass = htmlEl.className;
  htmlEl.className = `${htmlClass  } ie8-font-fix`;

  _.defer(function() {
    htmlEl.className = htmlClass;
    return head.removeChild(style);
  });
}


// Various methods to run on dom ready
Slzr.jQuery(function($) {
  // Extract localist meta tags into Slzr.Meta

  Slzr.Meta = {};
  $('meta[name|="localist"]').each(function() {
    let name = $(this).attr('name');
    let content = $(this).attr('content') || '';

    // Automatically decode JSON-encoded arrays and objects
    if ((typeof(content) === 'string') && ((content.charAt(0) === '{') || (content.charAt(0) === '['))) { content = $.parseJSON(content); }

    // Decode booleans
    if (content === "true") { content = true; }
    if (content === "false") { content = false; }
    if (content === '') { content = null; }

    name = name.substring(9); // remove "localist-" prefix
    Slzr.Meta[name] = content;
    return true;
  });

  $(document).on('click', 'a[data-action="toggle"]', function(ev) {
    const $this = $(this);
    const $target = $($this.data('target'));
    $target.toggle();
    if ($this.data('hide-me')) { $this.hide(); }
    if ($this.data('toggle-class')) { $this.toggleClass($this.data('toggle-class')); }
    return false;
  });

  $(document).on('click', '[data-action="toggle-class"]', function(ev) {
    const $this = $(this);
    const $target = $($this.data('target'));
    $target.toggleClass($this.data('class') || $this.data('toggle-class'));
    return false;
  });

  $(document).on('click', '[data-ignore]', function(event) {
    console.log('ignore click', event);
    event.preventDefault();
    event.stopPropagation();
    return false;
  });

  // Handler for displaying popup windows from links
  //
  // Expects data-popup=true, data-popup-name and data-popup-options can also be set
  $(document).on('click', '[data-popup]', function(ev) {
    const target = $(ev.target).closest('[data-popup]');
    const href = target.attr('href');
    const name = target.data('popup-name');
    const options = target.data('popup-options');

    window.open(href, name, options);
    return ev.preventDefault();
  });

  $(document).on('ajax:success', '[data-update]', function(ev, data) {
    const target = $($(ev.target).data('update'));
    return $(target).html(data);
  });

  // Call the calendar item refresh
  $(document).on('ajax:success', '[data-complete]', function(ev, data) {
    const target = $(ev.target);
    const args = target.data('complete');

    return refreshItem(args[0], args[1], args[2], args[3]);
});

  $(document).onAction('hide-notice', () => hideNotice());

  // Actiavte rich text editor lightbox from a link
  $(document).onAction('edit-description', function() {
    let editor = null;

    return $.fancybox({
      href: '#x-edit-description',
      onStart() {
        return editor = CKEDITOR.replace($('#x-text-editor')[0]);
      },
      onCleanup() {
        editor.destroy();
        return editor = null;
      }
    });
  });

  // Reinitialize dynamic autocompletes when ajax happens and returns
  // a html or script response
  $(document).ajaxSuccess(function(event, xhr, settings) {
    const response_type = xhr.getResponseHeader('content-type');

    const is_script = response_type != null ? response_type.match(settings.contents.script) : undefined;
    const is_html = response_type != null ? response_type.match(settings.contents.html) : undefined;

    if (is_script || is_html) { return Slzr.initializeAutocompletes(); }
  });

  // Display an alert dialog when an element with data-alert is clicked. This stops
  // the default action of the click.
  return document.addEventListener('click', function(event) {
    const button_el = event.target.closest('[data-alert]');
    if (button_el) {
      event.preventDefault();
      return alert(button_el.dataset.alert);
    }
  });
});
